import { useEffect, useState } from "react";
import { api } from "@/lib/soul";

const TYPE_LABEL = {
  "red-letter": "Red Letter",
  teaching: "Ethiopian Canon",
  quote: "Wisdom",
  prompt: "Sit with this",
  word: "Word of the Day",
};

export default function RevolvingBanner() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);
  const [show, setShow] = useState(true);

  useEffect(() => {
    api.get("/feed").then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (items.length === 0) return;
    const t = setInterval(() => {
      setShow(false);
      setTimeout(() => {
        setIdx((i) => (i + 1) % items.length);
        setShow(true);
      }, 500);
    }, 6000);
    return () => clearInterval(t);
  }, [items]);

  if (items.length === 0) return null;
  const item = items[idx];
  const isRed = item.type === "red-letter";

  return (
    <section data-testid="revolving-banner" className="max-w-7xl mx-auto px-6 my-16">
      <div className="glass rounded-3xl p-10 sm:p-16 relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-40"
          style={{
            background: isRed
              ? "radial-gradient(600px 300px at 80% -20%, rgba(193,39,45,0.25), transparent 60%)"
              : "radial-gradient(600px 300px at 80% -20%, rgba(212,175,55,0.18), transparent 60%)",
          }}
        />
        <div
          className="relative z-10 transition-opacity duration-500"
          style={{ opacity: show ? 1 : 0 }}
          data-testid="revolving-item"
        >
          <p
            className="text-xs uppercase tracking-[0.3em] mb-6"
            style={{ color: isRed ? "#C1272D" : "#D4AF37" }}
          >
            {TYPE_LABEL[item.type] || "Reflection"}
          </p>
          <blockquote
            className="italic-serif text-3xl sm:text-5xl leading-snug max-w-4xl"
            style={{ color: isRed ? "#C1272D" : "#F5F1E7" }}
          >
            “{item.text}”
          </blockquote>
          <p className="mt-6 text-[#D4AF37] tracking-wide">
            — {item.author}
            {item.source ? <span className="text-[#A8A29E]"> · {item.source}</span> : null}
          </p>
          {item.reflection && (
            <p className="mt-4 text-[#A8A29E] leading-relaxed max-w-2xl">{item.reflection}</p>
          )}
        </div>

        <div className="relative z-10 mt-8 flex gap-1.5">
          {items.slice(0, 12).map((_, i) => (
            <span
              key={i}
              className="h-1 rounded-full transition-all duration-500"
              style={{
                width: i === idx % 12 ? 28 : 8,
                background: i === idx % 12 ? "#D4AF37" : "rgba(245,241,231,0.15)",
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
